/** Metadatos de carga enviados a POST /api/ingest/upload (#0000041). */
export interface IngestUploadMetaSnapshot {
  companyName: string;
  subfolderPath: string;
  description: string;
}

export function snapshotIngestUploadMeta(fields: {
  companyName: string;
  subfolderPath: string;
  description: string;
}): IngestUploadMetaSnapshot {
  return {
    companyName: fields.companyName.trim(),
    subfolderPath: (fields.subfolderPath ?? '').trim(),
    description: (fields.description ?? '').trim(),
  };
}

export function appendIngestUploadMetaFields(
  formData: FormData,
  snapshot: IngestUploadMetaSnapshot,
  projectName: string,
  isFolder: boolean,
  confirmNewVersion = false,
): void {
  formData.append('is_folder', isFolder ? 'true' : 'false');
  formData.append('project_name', projectName);
  formData.append('company_name', snapshot.companyName);
  formData.append('subfolder_path', snapshot.subfolderPath);
  formData.append('description', snapshot.description);
  if (confirmNewVersion) {
    formData.append('confirm_new_version', 'true');
  }
}

export function formatIngestUploadSubfolderLabel(path: string): string {
  const trimmed = path.trim();
  return trimmed || '(Raíz)';
}
